<template>
  <div>
    <md-toolbar class="md-primary MenuBar">
      <md-button class="md-icon-button" @click="menuOpen = !menuOpen">
        <md-icon>menu</md-icon>
      </md-button>
      <span class="md-title">
        <img
          class="MenuBar-logo"
          alt="Ticketlab"
          src="//ticketlab.co.uk/images/ticketlab_dark.svg"
        />
      </span>

      <div class="md-toolbar-section-end">
        <md-button @click="logout()">Log out</md-button>
      </div>
    </md-toolbar>

    <md-drawer
      class="MenuBar-drawer"
      :md-active.sync="menuOpen"
      md-swipeable>
      <md-toolbar class="md-transparent" md-elevation="0">
        <span class="md-title">
          <img
            class="MenuBar-logo"
            alt="Ticketlab"
            src="//ticketlab.co.uk/images/ticketlab_dark.svg"
          />
        </span>
      </md-toolbar>

      <md-list>
        <md-list-item
          v-for="(item, i) in navItems"
          :key="i"
          :to="item.to"
          @click="menuOpen = false">
          <md-icon>{{ item.icon }}</md-icon>
          <span class="md-list-item-text">{{item.title}}</span>
        </md-list-item>
      </md-list>
    </md-drawer>
  </div>
</template>

<script>
import './_MenuBar.scss';
import cookieModel from "../../models/cookie";
import {eventBus} from "../../models/events";

export default {
  mounted: function () {
    this.init();
  },
  methods: {
    init: function () {
      let vm = this;
      // TODO: this doesn't check logged in user, just that cookie has been set - not secure.
      vm.isLoggedIn = !!cookieModel.getCookie('ticketlab_access');
    },
    logout: function () {
      let vm = this;
      cookieModel.deleteAllNamedCookies('ticketlab_access');
      vm.isLoggedIn = false;

      vm.$router.push({
        name: 'Login'
      });
    }
  },
  data: function () {
    return {
      isLoggedIn: false,
      menuOpen: false,
      group: null,
      navItems: [
        {
          icon: 'dashboard',
          title: 'Dashboard',
          to: '/dashboard',
        },
        {
          icon: 'search',
          title: 'Search',
          to: '/search',
        },
        {
          icon: 'payment',
          title: 'Payments',
          to: '/payments/due',
        },
        {
          icon: 'receipt',
          title: 'Generate Invoice',
          to: '/invoices/generate',
        },
        {
          icon: 'email',
          title: 'Emails',
          to: '/emails',
        },
        {
          icon: 'query_stats',
          title: 'Reports',
          to: '/reports',
        },
        {
          icon: 'security',
          title: 'Spam Detection',
          to: '/spam',
        },
      ]
    }
  },
  created() {
    eventBus.$on('loggedIn', (isLoggedIn) => this.isLoggedIn = isLoggedIn);
  }
}

</script>
